import { useState, useEffect, useCallback } from "react";
import { getDetailPaymentPackage } from "shared/api/services";
import { ConceptsDeductionsRow } from "../helper/columnsConceptsDeductions";
import { mapDetailPaymentPackageToConceptsDeductions } from "../helper/mapperConceptsDeductions";

export const useDetailPaymentPackage = (consecutive?: string) => {
  const [conceptsDeductions, setConceptsDeductions] = useState<
    ConceptsDeductionsRow[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);

  const fetchConceptsDeductions = useCallback(
    async (currentPage?: number, currentSize?: number) => {
      if (!consecutive) {
        setConceptsDeductions([]);
        setTotalElements(0);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await getDetailPaymentPackage({
          consecutive,
          page: currentPage ?? page,
          size: currentSize ?? size,
        });
        const mappedData = mapDetailPaymentPackageToConceptsDeductions(
          response.content,
        );
        setConceptsDeductions(mappedData);
        setTotalElements(response.totalElements);
      } catch (err) {
        setError("Error al cargar los conceptos y deducciones");
        console.error("Error fetching detail payment package:", err);
      } finally {
        setIsLoading(false);
      }
    },
    [consecutive, page, size],
  );

  useEffect(() => {
    fetchConceptsDeductions();
  }, [fetchConceptsDeductions]);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    fetchConceptsDeductions(newPage, size);
  };

  const handleChangeSize = (newSize: number) => {
    setSize(newSize);
    setPage(0);
    fetchConceptsDeductions(0, newSize);
  };

  return {
    conceptsDeductions,
    isLoading,
    error,
    totalElements,
    page,
    size,
    handleChangePage,
    handleChangeSize,
    refetch: fetchConceptsDeductions,
  };
};
